/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-12-30
 * @description Implementation of user-request utilities to be used in the app.
 * @filename user-request.ts
 */

import { CreateUpdatePreviewInput } from "@radivision/graphql";
import { Environment, GraphQLTaggedNode } from "relay-runtime";
import { CREATE_CLAIM_REQUEST_GRAPHQL_MUTATION } from "../../relay/mutations/create-claim-request";
import { VERIFY_CLAIMER_PROFILE_USER_GRAPHQL_MUTATION } from "../../relay/mutations/verify-claim-profile-user";
import { ENVIRONMENT as RELAY_ENVIRONMENT } from "../../relay/relay-environment";
import { getClientMutationId } from "../general";
import { commitMutation } from "../relay";

/**
 *
 *
 * @export
 * @class Entity
 */
export class ClaimRequest {
  /**
   *
   *
   * @static
   * @param {*} entityInput
   * @param {Environment} [environment=RELAY_ENVIRONMENT]
   * @returns {Promise<any>}
   * @memberof Entity
   */
  static createClaimRequest(input: any, environment: Environment = RELAY_ENVIRONMENT): Promise<any> {
    // ... convert article input to  CreateArticleStoryInput
    let createRequestInput: any; // CreateClaimRequestInput
    let promise: Promise<any>;
    let config: { mutation: GraphQLTaggedNode; variables: {} };
    let previewsInput: CreateUpdatePreviewInput[];

    if (input.previews !== undefined && input.previews !== null && input.previews.length > 0) {
      // handle preview inputs
      // handle preview inputs
      previewsInput = [];
      for (const PREVIEW of input.previews) {
        previewsInput.push({
          kind: PREVIEW.kind,
          link: PREVIEW.link,
          mediaAsset: PREVIEW.mediaAsset,
        });
      }
    }

    createRequestInput = {
      clientMutationId: getClientMutationId(),
      description: input.description && input.description.length > 0 ? input.description.trim() : undefined,
      item: input.item && input.item.length > 0 ? input.item.trim() : undefined,
      personEmail: input.personEmail && input.personEmail.length > 0 ? input.personEmail.trim() : undefined,
      previews: previewsInput,
    };

    // initialize mutation configuration
    config = {
      mutation: CREATE_CLAIM_REQUEST_GRAPHQL_MUTATION,
      variables: {
        input: createRequestInput,
      },
    };
    //
    promise = commitMutation(environment, config);

    promise = promise.then((mutationResults: any) => {
      return mutationResults.createClaimRequest.hasErrors === false
        ? Promise.resolve(mutationResults.createClaimRequest.userRequest)
        : Promise.reject(mutationResults.createClaimRequest.errors);
    });

    return promise;
  }

  /**
   *
   *
   * @static
   * @param {string} email
   * @returns {Promise<any>}
   * @memberof UserRequest
   */
  static validateUserClaimRequest(email: string, environment: Environment = RELAY_ENVIRONMENT): Promise<any> {
    // ... convert article input to  CreateArticleStoryInput
    let createRequestInput: any;
    let promise: Promise<any>;
    let config: { mutation: GraphQLTaggedNode; variables: {} };

    createRequestInput = {
      clientMutationId: getClientMutationId(),
      email: email && email.length > 0 ? email.trim() : undefined,
    };

    // initialize mutation configuration
    config = {
      mutation: VERIFY_CLAIMER_PROFILE_USER_GRAPHQL_MUTATION,
      variables: {
        input: createRequestInput,
      },
    };
    //
    promise = commitMutation(environment, config);

    promise = promise.then((mutationResults: any) => {
      return mutationResults.verifyClaimProfileUser.hasErrors === false
        ? Promise.resolve(mutationResults.verifyClaimProfileUser.request)
        : Promise.reject(mutationResults.verifyClaimProfileUser.errors);
    });

    return promise;
  }
}
